import React, { useState } from 'react'
import EditIcon from '@material-ui/icons/Edit';
import { connect } from "react-redux";
import WmModals from "../../modals/Wm.Modals";
import Required from '../../Components/required/Required';
import Wmbutton from '../../ui-components/wm-button/Wm.button';
import { editHobbies,deleteHobbies } from "../../services/actions/actions"

function HobbiesPills({ data, id, resume,handleEditHobbies,handleDeleteHobbies }) {
    const [singleHobby, setSingleHobby] = useState({ title: '' })
    const [openEditModal, setOpenEditModal] = useState(false)
    const [currentId,setCurrentId] = useState('')
    const getHobbyDetail = (id) => {
        setCurrentId(id)
        setOpenEditModal(true)
        setSingleHobby({ title: resume.hobbies[id].title })
    }
    return (
        <>
            <div className='cursor-pointer px-3 py-2 rounded-2xl bg-gray-200 shadow-md mr-3 mb-3 transition duration-150 ease-out hover:ease-in' onClick={() => getHobbyDetail(id)}>
                <div className='flex items-center'>
                    <span className='manpro font-medium text-base'>{data.title}</span>
                    <EditIcon className='ml-3' style={{ fontSize: '20px' }} />
                </div>
            </div>
            <WmModals show={openEditModal} onHide={() => setOpenEditModal(false)} size="lg" className="">
                <div className="modal--head border-b border-gray-400 border-solid py-3">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <h4 className="modal-title manpro font-bold text-2xl">Hobbies and interests</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal--body border-b border-gray-400 border-solid py-3">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="wm_form_group flex flex-col">
                                    <label className="wm_form_label"> Title <Required /></label>
                                    <input type="text" name="institute" required className="wm_form_input border-bottom border-gray-300" value={singleHobby.title} onChange={(e) => setSingleHobby({title: e.target.value})}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal--foot py-3">
                    <div className="container-fluid">
                        <div className="row justify-end px-3">
                            <div className="space-x-3">
                                <Wmbutton className="px-4 rounded" label="Save" type="button" color="primary" onClick={() => {handleEditHobbies(currentId,singleHobby);setOpenEditModal(false)}}/>
                                <Wmbutton className="px-4 rounded" label="Delete" bordered type="button" color="primary-border" onClick={() => {handleDeleteHobbies(currentId);setOpenEditModal(false)}}/>
                                <Wmbutton className="px-4 rounded" label="Cancel" bordered type="button" color="primary-border" onClick={() => setOpenEditModal(false)}/>
                            </div>
                        </div>
                    </div>
                </div>
            </WmModals>
        </>
    )
}


const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToState = (dispatch) => {
    return {
        handleEditHobbies: (id, value) => {
            dispatch(editHobbies(id,value))
        },
        handleDeleteHobbies: (id) => {
            dispatch(deleteHobbies(id))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToState)(HobbiesPills)
